import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";

const ApplicationsGrid = ({ applications }) => {
  const navigate = useNavigate();

  const handleOpenApplication = (id, redirectTo) => {
    navigate(`/${redirectTo}/${id}`);
  };

  return (
    <div className="card">
      <div className="card-body">
        {applications?.length > 0}
        <table className="bordered-table-applications">
          <thead>
            <tr>
              <th>#</th>
              <th>A/A Υποβολής</th>
              <th>Ημερομηνία</th>
              <th>Έτος</th>
              <th>Τύπος</th>
              <th>Καταστάση</th>
              <th align="center">Ενέργειες</th>
            </tr>
          </thead>
          {applications?.length > 0 ? (
            <tbody>
              {applications?.map((application) => {
                return (
                  <tr key={application?.id}>
                    <td>{application?.position}</td>
                    <td>{application?.protocolNumber}</td>
                    <td>
                      {application?.submitted?.dateFormatted !== ""
                        ? application?.submitted?.dateFormatted
                        : application?.created?.dateFormatted}
                    </td>
                    <td>{application?.season?.name}</td>
                    <td>{application?.type?.name}</td>
                    <td>{application?.status?.name}</td>
                    <td>
                      {application?.canEdit ? (
                        <div className="action-buttons">
                          <button
                            onClick={() =>
                              handleOpenApplication(application?.id, application?.redirectTo)
                            }
                            className="btn btn-edit"
                            aria-label="Επεξεργασία Αίτησης"
                          >
                            <EditIcon />
                          </button>
                        </div>
                      ) : (
                        <div className="action-buttons">
                          <button
                            onClick={() =>
                              handleOpenApplication(application?.id, application?.redirectTo)
                            }
                            className="btn btn-view"
                            aria-label="Προβολή Αίτησης"
                          >
                            <VisibilityIcon />
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          ) : (
            <tr>
              <td
                colSpan="8"
                align="center"
                style={{ border: "none", padding: 20 }}
              >
                <h3 style={{ fontSize: "1.25em" }}> Δεν βρέθηκαν αιτήσεις.</h3>
              </td>
            </tr>
          )}
        </table>
      </div>
    </div>
  );
};

export default ApplicationsGrid;
